export enum SelectedTabEnum {
  HEALTH_OF_OPERATIONS = "healthOfOperations",
  PASSENGER_FLOW = "passengerFlow",
  DATE_TIME = "dateTime",
  KPI_CONFIGURATION = "kpiConfiguration",
}

export enum TouchPointName {
  AirportEntry = "airportEntry",
  CheckIn = "checkIn",
  Boarding = "boarding",
  Security = "security",
}

const PAXEnum = {
  TouchPointName,
};

export enum PAXRowEnum {
  PassengerCount = "Passenger count",
  WaitTime = "Wait time",
  QueueLength = "Queue length",
  EffectiveCurbUtilisation = "Effective curb utilisation",
  EffectiveParkingUtilisation = "Effective parking utilisation",
  Undefined = "undefined",
}

export enum SelectedTouchPointFilterName {
  CurbsideDropoff = "effectiveCurbUtilisation",
  CarPark = "effectiveParkingUtilisation",
  PublicTransport = "publicTransport",
}

export default PAXEnum;

export enum DateTimeSettingsEnum {
  RollingHrs = "rolling",
  TimeDuration = "fixed",
}
